<div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-text">
                    <h2>A PROPOS DE LA BSTP</h2>
                    <ul>
                        <li><a routerLink="/">ACCUEIL</a></li>
                        <li><i class="icofont-simple-right"></i></li>
                        <li>A PROPOS DE LA BSTP</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Section Notre Histoire -->
<div class="about-story-section pt-100 pb-100">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <div class="story-content">
                    <div class="section-badge animate__animated animate__fadeInLeft">
                        <span>Notre Histoire</span>
                    </div>
                    <h2 class="section-title animate__animated animate__fadeInLeft animate__delay-1s">
                        Une Vision pour l'Avenir de la Guinée
                    </h2>
                    <div class="story-text animate__animated animate__fadeInLeft animate__delay-2s">
                        <p>
                            La BSTP est née d'une vision audacieuse : transformer le paysage économique 
                            de la Guinée en créant une plateforme innovante qui connecte les entreprises 
                            locales avec des opportunités d'affaires de qualité.
                        </p>
                        <p>
                            Notre mission est de dynamiser le marché de la sous-traitance en favorisant 
                            des partenariats durables et en accompagnant l'innovation. Avec notre équipe 
                            dévouée et notre approche axée sur l'excellence, nous sommes là pour soutenir 
                            votre succès et contribuer au développement économique de notre pays.
                        </p>
                    </div>
                    <div class="story-features animate__animated animate__fadeInLeft animate__delay-3s">
                        <div class="feature-item">
                            <div class="feature-icon">
                                <i class="icofont-handshake"></i>
                            </div>
                            <div class="feature-content">
                                <h4>Partenariats Durables</h4>
                                <p>Créer des relations commerciales solides et durables</p>
                            </div>
                        </div>
                        <div class="feature-item">
                            <div class="feature-icon">
                                <i class="icofont-innovation"></i>
                            </div>
                            <div class="feature-content">
                                <h4>Innovation Continue</h4>
                                <p>Encourager l'innovation et l'excellence</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="story-images animate__animated animate__fadeInRight">
                    <div class="image-grid">
                        <div class="image-item large">
                            <img src="./assets/img/upload/about/359x522.png" alt="BSTP Histoire" />
                        </div>
                        <div class="image-item small">
                            <img src="./assets/img/upload/about/245x331.png" alt="BSTP Vision" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Section Notre Mission -->
<div class="mission-section pt-100 pb-100">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <div class="mission-images animate__animated animate__fadeInLeft">
                    <div class="image-stack">
                        <div class="stack-item">
                            <img src="./assets/img/upload/about/342x514.png" alt="Mission BSTP" />
                        </div>
                        <div class="stack-item">
                            <img src="./assets/img/upload/about/252x306.png" alt="Vision" />
                        </div>
                        <div class="stack-item">
                            <img src="./assets/img/upload/about/252x213.png" alt="Objectifs" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="mission-content animate__animated animate__fadeInRight">
                    <div class="section-badge">
                        <span>Notre Mission</span>
                    </div>
                    <h2 class="section-title">
                        Promouvoir le Contenu Local
                    </h2>
                    <div class="mission-text">
                        <p>
                            La BSTP s'engage à promouvoir le contenu local en habilitant les entreprises 
                            guinéennes à réaliser leur plein potentiel. Nous offrons un accès aux opportunités 
                            d'affaires, un renforcement des capacités, des solutions de financement et la 
                            création de partenariats, tout en cultivant l'excellence, l'inclusivité, 
                            l'intégrité et l'innovation.
                        </p>
                    </div>
                    <div class="mission-values">
                        <div class="value-item">
                            <div class="value-icon">
                                <i class="icofont-excellence"></i>
                            </div>
                            <h4>Excellence</h4>
                            <p>Maintenir les plus hauts standards de qualité</p>
                        </div>
                        <div class="value-item">
                            <div class="value-icon">
                                <i class="icofont-inclusivity"></i>
                            </div>
                            <h4>Inclusivité</h4>
                            <p>Assurer l'égalité d'accès aux opportunités</p>
                        </div>
                        <div class="value-item">
                            <div class="value-icon">
                                <i class="icofont-integrity"></i>
                            </div>
                            <h4>Intégrité</h4>
                            <p>Agir avec honnêteté et transparence</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Section Notre Équipe -->
<div class="team-section pt-100 pb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 text-center">
                <div class="section-header animate__animated animate__fadeInUp">
                    <div class="section-badge">
                        <span>Notre Équipe</span>
                    </div>
                    <h2 class="section-title">
                        Des Professionnels Dévoués
                    </h2>
                    <p class="section-subtitle">
                        L'équipe de la BSTP est composée de professionnels dévoués et passionnés, 
                        engagés à soutenir le développement économique de la Guinée.
                    </p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-8 mx-auto">
                <div class="team-description animate__animated animate__fadeInUp animate__delay-1s">
                    <p>
                        Forts de notre expertise et de notre engagement envers l'excellence, 
                        nous travaillons chaque jour pour offrir à nos membres les meilleures 
                        opportunités commerciales et les solutions les plus innovantes.
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Section Nos Services -->
<div class="services-section pt-100 pb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-6">
                <div class="service-card animate__animated animate__fadeInLeft">
                    <div class="card-header">
                        <div class="service-icon">
                            <i class="icofont-business-opportunity"></i>
                        </div>
                        <h3>Nos Offres</h3>
                    </div>
                    <div class="card-body">
                        <p>
                            Explorez nos services personnalisés conçus pour répondre à vos besoins 
                            spécifiques en matière d'opportunités d'affaires, de solutions de financement, 
                            de renforcement des capacités et de création de partenariats durables.
                        </p>
                        <ul class="service-features">
                            <li><i class="icofont-check-circled"></i> Opportunités d'affaires exclusives</li>
                            <li><i class="icofont-check-circled"></i> Solutions de financement innovantes</li>
                            <li><i class="icofont-check-circled"></i> Programmes de renforcement des capacités</li>
                            <li><i class="icofont-check-circled"></i> Création de partenariats stratégiques</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="service-card animate__animated animate__fadeInRight">
                    <div class="card-header">
                        <div class="service-icon">
                            <i class="icofont-commitment"></i>
                        </div>
                        <h3>Nos Engagements</h3>
                    </div>
                    <div class="card-body">
                        <p>
                            Nous nous engageons à vous fournir des services de la plus haute qualité, 
                            dans le respect de l'inclusivité, de l'intégrité et de l'innovation.
                        </p>
                        <ul class="service-features">
                            <li><i class="icofont-check-circled"></i> Éthique de travail irréprochable</li>
                            <li><i class="icofont-check-circled"></i> Dévouement sans faille à votre succès</li>
                            <li><i class="icofont-check-circled"></i> Transparence dans toutes nos actions</li>
                            <li><i class="icofont-check-circled"></i> Innovation continue dans nos services</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Section Call to Action -->
<div class="cta-section pt-100 pb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 text-center">
                <div class="cta-content animate__animated animate__fadeInUp">
                    <h2 class="text-white">Prêt à Rejoindre BSTP ?</h2>
                    <p>
                        Découvrez comment nous pouvons vous aider à développer votre entreprise 
                        et à accéder à de nouvelles opportunités commerciales.
                    </p>
                    <div class="cta-buttons">
                        <a routerLink="/create-account" class="btn btn-primary">
                            <i class="icofont-user"></i>
                            Créer un Compte
                        </a>
                        <a routerLink="/contact" class="btn btn-outline-primary">
                            <i class="icofont-envelope"></i>
                            Nous Contacter
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
